import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,

    "ContainerDiv": styled.div`
        display: flex;
        gap: 20px;
    `,
    "AreaDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.small_bold};
        }
    `,

    "SliderDiv": styled.div`
        width: 400px;
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 4px;

        & > button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            background-color: ${({ theme }) => theme.color.grey1};
            border-radius: 4px;

            & >img {
                height: 12px;
            }
        }
    `,
    "ContentImg": styled.img`
        width: 400px;
    `,
}